import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { languages, fallbackLng } from 'constants/languages';

const whitelist = languages.map(language => language.code);

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng,
    debug: false,
    whitelist,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
